var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOaLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-730517f1-f287-47b3-8c70-dfacbdad1ade",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "163.4px",
    height: "34.2px",
    viewBox: "0 0 163.4 34.2",
    style: {
      enableBackground: "new 0 0 163.4 34.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#583D6B;}\n\t.st1{fill:url(#SVGID_1_);}\n\t.st2{fill:url(#SVGID_00000174602014389772700830000010094749149476856766_);}\n\t.st3{fill:url(#SVGID_00000103968667297138529730000007774131995031891846_);}\n\t.st4{fill:url(#SVGID_00000024002168758048103980000009148867042123924608_);}\n\t.st5{fill:url(#SVGID_00000091710694522972764570000015475135621303668910_);}\n\t.st6{fill:url(#SVGID_00000169519510133148052060000016299552353502786718_);}\n\t.st7{fill:#F1B300;}\n")), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M137.7,15.7c1.1,0,2.1,0.2,3,0.6c0.9,0.4,1.7,1,2.4,1.7s1.2,1.5,1.6,2.5c0.4,0.9,0.6,2,0.6,3 c0,1.1-0.2,2.1-0.6,3c-0.4,0.9-0.9,1.8-1.6,2.5c-0.7,0.7-1.5,1.3-2.4,1.7c-0.9,0.4-1.9,0.6-3,0.6c-0.9,0-1.6-0.1-2.3-0.4 c-0.3-0.1-0.5-0.5-0.4-0.8l0.9-2.5c0.1-0.3,0.4-0.4,0.7-0.4c5,0.1,4.7-3.5,4.6-4.2c-0.2-3.8-7.4-4.6-7.4,0.6v6.2v3.9 c0,0.3-0.3,0.6-0.6,0.6h-2.9c-0.3,0-0.6-0.3-0.6-0.6v-17c0-0.3,0.3-0.6,0.6-0.6h2.3c0.3,0,0.6,0.3,0.6,0.6v0.5 c0.6-0.5,1.2-0.8,2-1.1C135.9,15.8,136.8,15.7,137.7,15.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M155.9,15.7c1.1,0,2.1,0.2,3,0.6c0.9,0.4,1.7,1,2.4,1.7s1.2,1.5,1.6,2.5c0.4,0.9,0.6,2,0.6,3 c0,1.1-0.2,2.1-0.6,3c-0.4,0.9-0.9,1.8-1.6,2.5c-0.7,0.7-1.5,1.3-2.4,1.7c-0.9,0.4-1.9,0.6-3,0.6c-0.9,0-1.6-0.1-2.3-0.4 c-0.3-0.1-0.5-0.5-0.4-0.8l0.9-2.5c0.1-0.3,0.4-0.4,0.7-0.4c5,0.1,4.7-3.5,4.6-4.2c-0.2-3.8-7.4-4.6-7.4,0.6v6.2v3.9 c0,0.3-0.3,0.6-0.6,0.6h-2.9c-0.3,0-0.6-0.3-0.6-0.6v-17c0-0.3,0.3-0.6,0.6-0.6h2.3c0.3,0,0.6,0.3,0.6,0.6v0.5 c0.6-0.5,1.2-0.8,2-1.1C154.2,15.8,155,15.7,155.9,15.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 107.4235,
    y1: 31.7279,
    x2: 120.3259,
    y2: 8.3174,
    gradientTransform: "matrix(1 0 0 -1 0 33.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDC5D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2826,
    style: {
      stopColor: "#9787A5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5561,
    style: {
      stopColor: "#68527B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6887,
    style: {
      stopColor: "#563D6B"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M113.2,3.5c-2.1-2.2-5.4-1.5-6.2,0.9c3.4,1,9.5,14.6,10.5,23.7c0.7,6.1,1.2,5.4,2.9,4.6c2.1-1,3.4-3.5,2.5-8 C121.6,18,117.5,8,113.2,3.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000165916517288679229260000017086969253761423760_",
    gradientUnits: "userSpaceOnUse",
    x1: 25.7309,
    y1: -13.5596,
    x2: 26.8948,
    y2: 0.4083,
    gradientTransform: "matrix(0.9999 1.097317e-02 1.097317e-02 -0.9999 72.8906 15.4214)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDC5D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2826,
    style: {
      stopColor: "#9787A5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5561,
    style: {
      stopColor: "#68527B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6887,
    style: {
      stopColor: "#563D6B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000165916517288679229260000017086969253761423760_)"
    },
    d: "M100.1,23.7c-1.4-1-3.1-2.5-4.3-3.5 c-0.5,2.1-1.1,5.1-1.3,6.9c-0.4,3.5,0.8,4.9,2.3,5.4c0.9,0.3,4.6-1.1,5.9-3.8C100.1,29.3,99.7,26.8,100.1,23.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000142864340588715868230000010197554995058526624_",
    gradientUnits: "userSpaceOnUse",
    x1: 121.2521,
    y1: 3.7561,
    x2: 92.6499,
    y2: 20.5415,
    gradientTransform: "matrix(1 0 0 -1 0 33.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#563D6B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.927,
    style: {
      stopColor: "#BCB1C6"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000142864340588715868230000010197554995058526624_)"
    },
    d: "M104.2,21.7 c-5.7-3.6-11.9-8.2-11.4-10.6c-1.4,2.7-0.8,6.1,2.1,8.2c7.8,7.1,21.8,16.2,26.4,14.1c2.1-1,2.3-5.1,1.4-9.1 C123.5,30.6,109.7,25.1,104.2,21.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000128445186349869935560000008982049849723235743_",
    gradientUnits: "userSpaceOnUse",
    x1: 18.4607,
    y1: -0.4866,
    x2: 36.0748,
    y2: 9.2836,
    gradientTransform: "matrix(0.9999 1.097317e-02 1.097317e-02 -0.9999 72.8906 15.4214)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#563D6B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.927,
    style: {
      stopColor: "#BCB1C6"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000128445186349869935560000008982049849723235743_)"
    },
    d: "M95,19.4c-4.2-2.9-5.8-6.4-4.8-8.7 c2.2-4.9,13.8-2.3,18.5-0.2c0.9,0.4,1.9,1.2,2,1.8s-0.5,0.3-1.8-0.2c-2.2-0.8-8.9-2.9-13.1-0.6C92.4,13.5,92.7,17.2,95,19.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000125575840221531681550000010042474090233703060_",
    gradientUnits: "userSpaceOnUse",
    x1: 27.7049,
    y1: -1.7773,
    x2: 36.2436,
    y2: 14.8869,
    gradientTransform: "matrix(0.9999 1.097317e-02 1.097317e-02 -0.9999 72.8906 15.4214)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDC5D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2826,
    style: {
      stopColor: "#9787A5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5561,
    style: {
      stopColor: "#68527B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6887,
    style: {
      stopColor: "#563D6B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000125575840221531681550000010042474090233703060_)"
    },
    d: "M101.1,19.6c0.3-1.4,0.4-2,0.9-3.6 c2.5-8.5,6.9-15.3,11.2-12.5c-2.1-2.2-3.6-3.8-6.2-3.3c-3.3,0.7-7.7,8.5-10.2,16.4C97.9,17.4,99.8,18.8,101.1,19.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000060714046909565439420000012912347656629948859_",
    gradientUnits: "userSpaceOnUse",
    x1: 94.1827,
    y1: 13.0093,
    x2: 131.1823,
    y2: 13.0093,
    gradientTransform: "matrix(1 0 0 -1 0 33.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1747,
    style: {
      stopColor: "#4F3863"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2747,
    style: {
      stopColor: "#7B5948"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#E9AD05"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5153,
    style: {
      stopColor: "#F1B300"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000060714046909565439420000012912347656629948859_)"
    },
    d: "M128.7,7.8c-1.4,0-2.5,1.1-2.5,2.5 c0,0.1,0,0.2,0,0.2c-2.7,6.6-20.4,14.2-24.4,16.8c-5,3.3-7.5,0.3-7.5,0.3l0,0c-0.4,3.7-0.2,5.9,1.3,6.3 c4.8,1.4,30.6-21.6,32.8-21.3c0.1,0,0.2,0,0.3,0c1.4,0,2.5-1.1,2.5-2.5C131.2,9,130.1,7.8,128.7,7.8z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M26.6,15.7c1.1,0,2.1,0.2,3,0.6c0.9,0.4,1.7,1,2.4,1.7c0.7,0.7,1.2,1.5,1.6,2.5c0.4,0.9,0.6,2,0.6,3 c0,1.1-0.2,2.1-0.6,3c-0.4,0.9-0.9,1.8-1.6,2.5c-0.7,0.7-1.5,1.3-2.4,1.7c-0.9,0.4-1.9,0.6-3,0.6c-0.9,0-1.6-0.1-2.3-0.4 c-0.3-0.1-0.5-0.5-0.4-0.8l0.9-2.5c0.1-0.3,0.4-0.4,0.7-0.4c5,0.1,4.7-3.5,4.6-4.2c-0.2-3.8-7.4-4.6-7.4,0.6v6.2v3.9 c0,0.3-0.3,0.6-0.6,0.6h-2.9c-0.3,0-0.6-0.3-0.6-0.6v-17c0-0.3,0.3-0.6,0.6-0.6h2.3c0.3,0,0.6,0.3,0.6,0.6v0.5 c0.6-0.5,1.2-0.8,2-1.1C24.8,15.8,25.6,15.7,26.6,15.7z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M80.3,16c1.2,0,2.2,0.2,3.1,0.7c0.9,0.4,1.7,1,2.4,1.8c0.7,0.8,1.2,1.7,1.6,2.7s0.5,2.1,0.5,3.2v9.8h-4.2v-9.8 c0-1.2-0.4-2.2-1.2-2.9c-0.8-0.8-1.8-1.2-2.9-1.2c-1.2,0-2.1,0.4-2.9,1.2c-0.8,0.8-1.2,1.8-1.2,2.9v9.8h-4.2V16.5h4.2v1.3 c0.6-0.5,1.4-1,2.2-1.3C78.4,16.1,79.3,16,80.3,16z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M39.6,34.1L39.6,34.1c-1.2,0-2.1-0.9-2.1-2V17.9c0-1.1,0.9-2,2-2h0.1c1.1,0,2,0.9,2,2v14.2 C41.5,33.2,40.7,34.1,39.6,34.1z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M14.5,14.4c0.4,0,0.7-0.3,0.7-0.7v-2.6c0-0.4-0.3-0.7-0.7-0.7H5.3H0.7H0v0.7v2.6v17.1v2.6v0.7h0.7h4.6h9.2 c0.4,0,0.7-0.3,0.7-0.7v-2.6c0-0.4-0.3-0.7-0.7-0.7H5.3v-5.8h8.5c0.4,0,0.7-0.3,0.7-0.7V21c0-0.4-0.3-0.7-0.7-0.7H5.3v-5.8 L14.5,14.4L14.5,14.4z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M56.9,10.4c1.6,0,3.2,0.3,4.6,0.9c1.4,0.6,2.7,1.5,3.8,2.5c1.1,1.1,1.9,2.3,2.5,3.8c0.6,1.4,0.9,3,0.9,4.6 s-0.3,3.2-0.9,4.6s-1.5,2.7-2.5,3.8c-1.1,1.1-2.3,1.9-3.8,2.5c-1.4,0.6-3,0.9-4.6,0.9s-3.2-0.3-4.6-0.9c-1.4-0.6-2.7-1.5-3.8-2.5 c-1.1-1.1-1.9-2.3-2.5-3.8c-0.6-1.4-0.9-3-0.9-4.6s0.3-3.2,0.9-4.6c0.6-1.4,1.5-2.7,2.5-3.8c1.1-1.1,2.3-1.9,3.8-2.5 C53.8,10.7,55.3,10.4,56.9,10.4z M56.9,14.3c-1.1,0-2.1,0.2-3,0.6c-1,0.4-1.8,1-2.6,1.7c-0.8,0.8-1.3,1.6-1.7,2.6s-0.6,2-0.6,3 s0.2,2.1,0.6,3c0.4,1,1,1.8,1.7,2.6c0.8,0.8,1.6,1.3,2.6,1.7c1,0.4,2,0.6,3,0.6c1.1,0,2.1-0.2,3-0.6s1.8-1,2.6-1.7 c0.8-0.8,1.3-1.6,1.7-2.6c0.4-1,0.6-2,0.6-3s-0.2-2.1-0.6-3c-0.4-1-1-1.8-1.7-2.6c-0.8-0.8-1.6-1.3-2.6-1.7S58,14.3,56.9,14.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOaLogo);
export default __webpack_public_path__ + "static/media/OA_logo.39e84c965ca432e7e396f887f22f45c0.svg";
export { ForwardRef as ReactComponent };